exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* You can add global styles to this file, and also import other style files */\nhtml { \n    background: url(/assets/images/thought1.jpeg) no-repeat center center fixed;\n    background-size: cover;\n  }\n\nbody { \n  background: none !important;\n}\n.white-text {\n  color: #FFFFFF !important;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /var/www/html/project/snsina/node_modules/css-loader?{"sourceMap":false,"importLoaders":1}!/var/www/html/project/snsina/node_modules/postcss-loader?{"ident":"postcss"}!/var/www/html/project/snsina/src/styles.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/index.js?{"ident":"postcss"}!../../../../../src/styles.css
// module chunks = styles